import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index/index' //首页
import Volunteer from "@/views/volunteer/index.vue"//志愿填报界面
import Home from "@/views/home/index.vue"//个人中心
import School from "@/views/school/index.vue"//院校信息库
import SchoolDetail from "@/views/school/detail.vue"//院校详情
import Appraisal from "@/views/appraisal/index.vue"//测评中心
import AppraisalMBTI from "@/views/appraisal/info.vue"//MBTI答题
import AppraisalmbtiResult from "@/views/appraisal/mbtiResult.vue"//mbti测试结果
import Hollander from "@/views/appraisal/Hollander.vue"//霍兰德测试
import HollanderResult from "@/views/appraisal/HollanderResult.vue"//霍兰德测试结果
import Major from "@/views/major/index.vue"//专业知识库
import MajorDetail from "@/views/major/detail.vue"//专业知识库详情
import Seating from "@/views/seating/index.vue"//查位次
import RecruitData from "@/views/RecruitData/index.vue"//查招生计划
import OmitData from "@/views/OmitData/index.vue"//批次线查询
import Collectionplan from "@/views/Collectionplan/index.vue"//征集计划
import ranking from "@/views/school/ranking.vue"//院校排行榜
import majorSeat from "@/views/majorSeat/index.vue"//专业排行
import comprehensive from "@/views/comprehensive/index.vue"//综合查询工具
import wenDetail from "@/views/index/wenDetail.vue"//文章详情
import zixunList from "@/views/zixun/index.vue"//资讯
import Aboutus from "@/views/aboutus/index.vue"//资讯
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta:{
        title:"启程志愿-首页",
        isHeader:true,
      }
    },
    {
      path:"/Volunteer",
      name:"Volunteer",
      component:Volunteer,
      meta:{
        title:"志愿导航",
        isHeader:false,
        isQuan:true
      }
    },
    {
      path:"/comprehensive",
      name:"comprehensive",
      component:comprehensive,
      meta:{
        title:"启程志愿-综合查询",
        isHeader:false,
        isQuan:true
      }
    },
    {
      path:"/Home",
      name:"Home",
      component:Home,
      meta:{
        title:"个人中心",
        isHeader:true,
      }
    },
    {
      path:"/School",
      name:"School",
      component:School,
      meta:{
        title:"院校信息库",
        isHeader:false,
      }
    },
    {
      path:"/Ranking",
      name:"Ranking",
      component:ranking,
      meta:{
        title:"院校排行榜",
        isHeader:false,
      }
    },
    {
      path:"/Major",
      name:"Major",
      component:Major,
      meta:{
        title:"专业知识库",
        isHeader:false
      }
    },
    {
      path:"/majorSeat",
      name:"/majorSeat",
      component:majorSeat,
      meta:{
        title:"专业排行",
        isHeader:false
      }
    },
    {
      path:"/SchoolDetail",
      name:"SchoolDetail",
      component:SchoolDetail,
      meta:{
        title:"院校详情",
        isHeader:false
      }
    },
    {
      path:"/MajorDetail",
      name:"MajorDetail",
      component:MajorDetail,
      meta:{
        title:"专业详情",
        isHeader:false
      }
    },
    {
      path:"/Seating",
      name:"Seating",
      component:Seating,
      meta:{
        title:"查位次",
        isHeader:false
      }
    },
    {
      path:"/RecruitData",
      name:"RecruitData",
      component:RecruitData,
      meta:{
        title:"招生计划（3+2+1）",
        isHeader:false
      }
    },
    {
      path:"/OmitData",
      name:"OmitData",
      component:OmitData,
      meta:{
        title:"批次线查询",
        isHeader:false
      }
    },
    {
      path:"/Collectionplan",
      name:"Collectionplan",
      component:Collectionplan,
      meta:{
        title:"征集计划查询",
        isHeader:false
      }
    },
    {
      path:"/Appraisal",
      name:"Appraisal",
      component:Appraisal,
      meta:{
        title:"测评中心",
        isHeader:false
      }
    },
    {
      path:"/Aboutus",
      name:"Aboutus",
      component:Aboutus,
      meta:{
        title:"关于我们",
        isHeader:true,
        isQuan:true
      }
    },
    {
      path:"/AppraisalMBTI",
      name:"AppraisalMBTI",
      component:AppraisalMBTI,
      meta:{
        title:"MBTI职业性格测试",
        isHeader:false,
        isQuan:true
      }
    },
    {
      path:"/AppraisalmbtiResult",
      name:"AppraisalmbtiResult",
      component:AppraisalmbtiResult,
      meta:{
        title:"MBTI职业性格测试报告",
        isHeader:false,
        isQuan:true
      }
    },
    {
      path:"/Hollander",
      name:"/Hollander",
      component:Hollander,
      meta:{
        title:"霍兰德职业兴趣测试",
        isHeader:false,
        isQuan:true
      }
    },
    {
      path:"/HollanderResult",
      name:"/HollanderResult",
      component:HollanderResult,
      meta:{
        title:"霍兰德职业兴趣测试报告",
        isHeader:false,
        isQuan:true
      }
    },
    {
      path:"/wenDetail",
      name:"/wenDetail",
      component:wenDetail,
      meta:{
        title:"高考资讯详情",
        isHeader:false,
        isQuan:true
      }
    },
    {
      path:"/zixun",
      name:"/zixun",
      component:zixunList,
      meta:{
        title:"高考资讯",
        isHeader:false,
        isQuan:true
      }
    }
  ]
})
const originalPush = Router.prototype.push
Router.prototype.push = function push(location){
  return originalPush.call(this,location).catch((err)=>err)
}



// WEBPACK FOOTER //
// ./src/router/index.js